export const DEV_URL = "http://192.168.15.2/timepay-api/public/api";
export const PROD_URL = "https://apibanking.timepay.com.br/api";
export const CLIENT_ID = "2";
export const CLIENT_SECRET = "vWJCrcaJzCqD2J0i7u6xRFaQXcAS07TbVDAkXvLK";
